import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('farmfleet_admin');
    if (stored) {
      try {
        setAdmin(JSON.parse(stored));
      } catch (e) {
        localStorage.removeItem('farmfleet_admin');
      }
    }
  }, []);

  const login = (adminData) => {
    setAdmin(adminData);
    localStorage.setItem('farmfleet_admin', JSON.stringify(adminData));
  };

  const logout = () => {
    setAdmin(null);
    localStorage.removeItem('farmfleet_admin');
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
